import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getShiftApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const getShift = createAsyncThunk('getShift', async (payload) => {
  return await getShiftApi(payload);
});

const getShiftSlice = createSlice({
  name: 'getShift', // Unique Name
  initialState,
  reducers: {
    getShiftReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getShift.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(getShift.fulfilled, (state, action) => {
        const { message = '', data = [], payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(getShift.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { getShiftReset } = getShiftSlice.actions;

export default getShiftSlice.reducer;
